/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceAssessmentControlListResponse {
    getFixupPrototypeFunction() { return ComplianceAssessmentControlListResponse.fixupPrototype; }

    static newInstance(model: Partial<ComplianceAssessmentControlListResponse>): ComplianceAssessmentControlListResponse {
        let obj = Object.assign(new ComplianceAssessmentControlListResponse(), model);
        ComplianceAssessmentControlListResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceAssessmentControlListResponse>): ComplianceAssessmentControlListResponse {
        if (!model) return null;
        return ComplianceAssessmentControlListResponse.newInstance(<ComplianceAssessmentControlListResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceAssessmentControlListResponse) {
        if (!obj) return;

        models.ComplianceAssessmentControlListResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceAssessmentControlListResponse): boolean {
        Object.setPrototypeOf(obj, ComplianceAssessmentControlListResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.next_list_context) {
            models.ListContext.fixupPrototype(this.next_list_context);
        }
    }

    /**
     * List of result identifiers
     */
    results: Array<string>;

    /**
     * List context
     */
    next_list_context: models.ListContext;

}
